import {
    getMedicos,
    getObrasSociales,
    getPacientes,
    getPlanes,
    getSedes,
    getServicios,
    getTurnos,
    getUsuarios,
} from "../../api/apiResources";

const formatDate = (value) => {
    if (!value) {
        return "-";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleString("es-AR");
};

const getId = (row) => row.id || row._id || "-";

export const resourcesConfig = {
    servicios: {
        title: "Servicios",
        subtitle: "Servicios y especialidades disponibles en el centro médico.",
        fetchData: getServicios,
        searchKeys: ["nombre", "descripcion", "tipoServicio"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "nombre", label: "Nombre" },
            { key: "descripcion", label: "Descripción" },
            { key: "tipoServicio", label: "Tipo" },
            { key: "duracionEnMinutos", label: "Duración" },
            { key: "costoConsulta", label: "Costo" },
            { key: "activo", label: "Activo" },
        ],
    },

    medicos: {
        title: "Médicos",
        subtitle: "Profesionales cargados en la base de datos.",
        fetchData: getMedicos,
        searchKeys: ["nombre", "apellido", "dni", "matricula", "especialidad"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "nombre", label: "Nombre" },
            { key: "apellido", label: "Apellido" },
            { key: "dni", label: "DNI" },
            { key: "matricula", label: "Matrícula" },
            { key: "activo", label: "Activo" },
            { key: "servicios", label: "Servicios" },
            { key: "sedes", label: "Sedes" },
        ],
    },

    pacientes: {
        title: "Pacientes",
        subtitle: "Pacientes registrados en el sistema.",
        fetchData: getPacientes,
        searchKeys: ["nombre", "apellido", "dni"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "nombre", label: "Nombre" },
            { key: "apellido", label: "Apellido" },
            { key: "dni", label: "DNI" },
            {
                key: "fechaNacimiento",
                label: "Fecha nacimiento",
                render: (row) => formatDate(row.fechaNacimiento),
            },
            { key: "activo", label: "Activo" },
            { key: "plan", label: "Plan" },
        ],
    },

    turnos: {
        title: "Turnos",
        subtitle: "Turnos creados, disponibles, reservados o modificados.",
        fetchData: getTurnos,
        searchKeys: ["estado"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "fechaHora", label: "Fecha y hora", render: (row) => formatDate(row.fechaHora) },
            { key: "estado", label: "Estado" },
            { key: "duracion", label: "Duración" },
            { key: "costo", label: "Costo" },
            { key: "id_medico", label: "Médico" },
            { key: "paciente", label: "Paciente" },
            { key: "sede", label: "Sede" },
            { key: "servicios", label: "Servicios" },
        ],
    },

    sedes: {
        title: "Sedes",
        subtitle: "Sedes y direcciones cargadas.",
        fetchData: getSedes,
        searchKeys: ["nombre", "direccion"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "nombre", label: "Nombre" },
            { key: "direccion", label: "Dirección" },
            { key: "activo", label: "Activo" },
        ],
    },

    usuarios: {
        title: "usuarios",
        subtitle: "usuarios guardados en el backend.",
        fetchData: getUsuarios,
        searchKeys: ["username", "nombre", "apellido", "email", "rol"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "username", label: "Usuario" },
            { key: "nombre", label: "Nombre" },
            { key: "apellido", label: "Apellido" },
            { key: "email", label: "Email" },
            { key: "rol", label: "Rol" },
            { key: "activo", label: "Activo" },
        ],
    },

    obrasSociales: {
        title: "Obras sociales",
        subtitle: "Obras sociales cargadas en el sistema.",
        fetchData: getObrasSociales,
        searchKeys: ["nombre", "codigo"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "nombre", label: "Nombre" },
            { key: "codigo", label: "Código" },
            { key: "activa", label: "Activa" },
            { key: "planes", label: "Planes" },
        ],
    },

    planes: {
        title: "Planes",
        subtitle: "Planes y coberturas disponibles.",
        fetchData: getPlanes,
        searchKeys: ["nombre", "codigo"],
        columns: [
            { key: "id", label: "ID", render: getId },
            { key: "nombre", label: "Nombre" },
            { key: "codigo", label: "Código" },
            { key: "activo", label: "Activo" },
            { key: "coberturas", label: "Coberturas" },
        ],
    },
};